import { render, staticRenderFns } from "./TransferShop.vue?vue&type=template&id=37198c2c&"
import script from "./TransferShop.vue?vue&type=script&lang=js&"
export * from "./TransferShop.vue?vue&type=script&lang=js&"
import style0 from "./TransferShop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransferShop.vue"
export default component.exports